
export default function Search({chaine, setChaine, search, placeholder}) {
    // states


    // comportement


    // affichage
    return (
        <form
            className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search"
            style={{float: "right"}}
            onSubmit={search}
        >
            <div className="input-group">
                <input 
                    type="text" 
                    className="form-control border-1 small" 
                    placeholder={placeholder}
                    aria-label="Rechercher"
                    style={{width: 296}}
                    value={chaine}
                    onChange={e => setChaine(e.target.value)}
                    autoComplete="off"
                />
                <div className="input-group-append">
                    <button className="btn btn-primary" type="submit">
                        <i className="fas fa-search fa-sm"></i>
                    </button>
                </div>
            </div>
        </form>
    )
}